import AlgoStrategiesPage from '../../components/algoStrategies/AlgoStrategiesPage';

const AlgosPage = () => {
	return <AlgoStrategiesPage />;
};

export default AlgosPage;
